export const caseStudies = [
  {
    id: 1,
    company: "Barbearia Premium",
    category: "Barbearia",
    owner: "Marcos Oliveira",
    role: "Proprietário",
    image: "https://public.readdy.ai/ai/img_res/882a8cde2c0f7994aef469531344c3c8.jpg",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-man-barbershop-owner-age-32-short-black-hair-beard-wearing-black-polo-shirt-confident-smile-professional-portrait-neutral-background-studio-lighting-high-quality-photography&width=200&height=200&seq=owner-marcos-oliveira&orientation=squarish",
    logo: "BP",
    testimonial: "A IA da NeuroAgents transformou completamente nosso atendimento. Antes perdíamos 40% dos clientes que ligavam fora do horário. Agora capturamos 100% e nosso faturamento explodiu.",
    challenge: "Perda de clientes que tentavam agendar fora do horário comercial e durante atendimentos. Equipe sobrecarregada respondendo WhatsApp.",
    solution: "Implementação de IA para atendimento 24/7 no WhatsApp com agendamento automático integrado ao sistema da barbearia.",
    results: [
      { metric: "Agendamentos", before: "120/mês", after: "210/mês", growth: "+75%" },
      { metric: "Faturamento", before: "R$ 18.000", after: "R$ 31.500", growth: "+75%" },
      { metric: "Tempo de Resposta", before: "2-4 horas", after: "Instantâneo", growth: "-100%" },
      { metric: "Clientes Perdidos", before: "40%", after: "2%", growth: "-95%" }
    ],
    timeline: "45 dias",
    mainMetric: "+75%",
    mainMetricLabel: "Aumento no Faturamento"
  },
  {
    id: 2,
    company: "Clínica Estética Renova",
    category: "Clínica",
    owner: "Dra. Camila Santos",
    role: "Diretora Clínica",
    image: "https://readdy.ai/api/search-image?query=Modern%20aesthetic%20clinic%20interior%20white%20clean%20minimalist%20design%20medical%20spa%20treatment%20room%20professional%20healthcare%20environment%20soft%20lighting&width=600&height=400&seq=case2&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-woman-doctor-age-42-long-brown-hair-wearing-white-medical-coat-elegant-professional-warm-smile-confident-expression-neutral-background-medical-professional-portrait-studio-lighting&width=200&height=200&seq=owner-camila-santos&orientation=squarish",
    logo: "CR",
    testimonial: "Nossos pacientes ficam impressionados com a rapidez e precisão das respostas. A IA conhece todos os nossos procedimentos e valores, e agenda consultas automaticamente.",
    challenge: "Recepcionistas não conseguiam atender todas as ligações. Muitos pacientes desistiam de agendar por demora no retorno.",
    solution: "IA treinada com todos os procedimentos, preços e protocolos da clínica. Integração com agenda online para marcação automática.",
    results: [
      { metric: "Consultas Agendadas", before: "80/mês", after: "145/mês", growth: "+81%" },
      { metric: "Taxa de Conversão", before: "35%", after: "68%", growth: "+94%" },
      { metric: "Ticket Médio", before: "R$ 450", after: "R$ 620", growth: "+38%" },
      { metric: "NPS", before: "72", after: "94", growth: "+31%" }
    ],
    timeline: "30 dias",
    mainMetric: "+81%",
    mainMetricLabel: "Mais Consultas"
  },
  {
    id: 3,
    company: "RM Imobiliária",
    category: "Imobiliária",
    owner: "Ricardo Mendes",
    role: "CEO",
    image: "https://readdy.ai/api/search-image?query=Modern%20real%20estate%20office%20interior%20professional%20workspace%20glass%20walls%20city%20view%20contemporary%20design%20luxury%20property%20agency&width=600&height=400&seq=case3&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-real-estate-agent-man-age-45-gray-hair-wearing-navy-blue-suit-white-shirt-confident-businessman-friendly-smile-professional-corporate-headshot-neutral-background-executive-portrait&width=200&height=200&seq=owner-ricardo-mendes&orientation=squarish",
    logo: "RM",
    testimonial: "A IA qualifica os leads automaticamente, pergunta orçamento, região de interesse e tipo de imóvel. Meus corretores só recebem leads quentes, prontos para visita.",
    challenge: "Corretores perdiam tempo com leads frios. Muitos interessados não eram respondidos a tempo e fechavam com concorrentes.",
    solution: "IA para qualificação automática de leads 24/7, com perguntas estratégicas e encaminhamento para corretores especializados.",
    results: [
      { metric: "Leads Qualificados", before: "45/mês", after: "120/mês", growth: "+167%" },
      { metric: "Vendas Fechadas", before: "8/mês", after: "19/mês", growth: "+138%" },
      { metric: "Tempo Qualificação", before: "48 horas", after: "5 minutos", growth: "-99%" },
      { metric: "Comissões", before: "R$ 96.000", after: "R$ 228.000", growth: "+138%" }
    ],
    timeline: "60 dias",
    mainMetric: "+138%",
    mainMetricLabel: "Mais Vendas"
  },
  {
    id: 4,
    company: "Studio Fitness AP",
    category: "Fitness",
    owner: "Ana Paula Ferreira",
    role: "Fundadora",
    image: "https://readdy.ai/api/search-image?query=Modern%20fitness%20studio%20interior%20gym%20equipment%20clean%20minimalist%20design%20workout%20space%20natural%20lighting%20contemporary%20health%20club&width=600&height=400&seq=case4&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-woman-fitness-instructor-age-35-athletic-build-blonde-ponytail-wearing-sporty-tank-top-energetic-smile-confident-posture-gym-background-blurred-professional-fitness-portrait-natural-lighting&width=200&height=200&seq=owner-ana-paula-ferreira&orientation=squarish",
    logo: "SF",
    testimonial: "Antes eu passava 3 horas por dia respondendo mensagens. Agora a IA faz isso por mim, e ainda vende pacotes de aulas automaticamente. Recuperei meu tempo e aumentei a receita.",
    challenge: "Proprietária sobrecarregada com atendimento. Perdia oportunidades de venda por não conseguir responder a tempo.",
    solution: "IA para atendimento completo: tira dúvidas sobre modalidades, horários, preços e fecha matrículas automaticamente.",
    results: [
      { metric: "Matrículas", before: "25/mês", after: "52/mês", growth: "+108%" },
      { metric: "Receita Recorrente", before: "R$ 12.500", after: "R$ 26.000", growth: "+108%" },
      { metric: "Horas Economizadas", before: "0", after: "90h/mês", growth: "+90h" },
      { metric: "Retenção Alunos", before: "65%", after: "88%", growth: "+35%" }
    ],
    timeline: "21 dias",
    mainMetric: "+108%",
    mainMetricLabel: "Mais Matrículas"
  },
  {
    id: 5,
    company: "AutoPrime Veículos",
    category: "Automotivo",
    owner: "Fernando Costa",
    role: "Diretor Comercial",
    image: "https://readdy.ai/api/search-image?query=Modern%20car%20dealership%20showroom%20interior%20luxury%20vehicles%20clean%20minimalist%20design%20professional%20automotive%20sales%20environment%20bright%20lighting&width=600&height=400&seq=case5&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-car-salesman-man-age-38-short-brown-hair-clean-shaven-wearing-light-blue-dress-shirt-professional-friendly-smile-automotive-dealership-background-corporate-portrait-professional-lighting&width=200&height=200&seq=owner-fernando-costa&orientation=squarish",
    logo: "AP",
    testimonial: "A IA responde sobre todos os veículos do estoque, envia fotos, vídeos e agenda test drives. Nossos vendedores focam apenas em fechar negócios.",
    challenge: "Vendedores perdiam tempo respondendo perguntas básicas. Leads esfriavam enquanto aguardavam retorno.",
    solution: "IA integrada ao sistema de estoque, com informações atualizadas de todos os veículos e agendamento de visitas.",
    results: [
      { metric: "Test Drives", before: "35/mês", after: "78/mês", growth: "+123%" },
      { metric: "Veículos Vendidos", before: "12/mês", after: "24/mês", growth: "+100%" },
      { metric: "Ticket Médio", before: "R$ 45.000", after: "R$ 52.000", growth: "+16%" },
      { metric: "Faturamento", before: "R$ 540.000", after: "R$ 1.248.000", growth: "+131%" }
    ],
    timeline: "45 dias",
    mainMetric: "+100%",
    mainMetricLabel: "Dobrou as Vendas"
  },
  {
    id: 6,
    company: "JR Consultoria Digital",
    category: "Consultoria",
    owner: "Juliana Rocha",
    role: "CEO",
    image: "https://readdy.ai/api/search-image?query=Modern%20digital%20agency%20office%20interior%20creative%20workspace%20computers%20monitors%20contemporary%20design%20professional%20tech%20company%20environment&width=600&height=400&seq=case6&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-businesswoman-age-36-shoulder-length-dark-hair-wearing-elegant-gray-blazer-professional-confident-smile-modern-office-background-executive-portrait-corporate-photography-natural-lighting&width=200&height=200&seq=owner-juliana-rocha&orientation=squarish",
    logo: "JR",
    testimonial: "Implementamos a IA para nossos próprios clientes e para nós mesmos. O resultado foi tão bom que agora revendemos a solução. Virou uma nova linha de receita.",
    challenge: "Equipe pequena não conseguia atender todos os leads. Perdia oportunidades por falta de capacidade de resposta.",
    solution: "IA para qualificação e nutrição de leads, com respostas sobre serviços e agendamento de reuniões de briefing.",
    results: [
      { metric: "Leads Atendidos", before: "60/mês", after: "180/mês", growth: "+200%" },
      { metric: "Propostas Enviadas", before: "15/mês", after: "42/mês", growth: "+180%" },
      { metric: "Contratos Fechados", before: "6/mês", after: "18/mês", growth: "+200%" },
      { metric: "MRR", before: "R$ 45.000", after: "R$ 135.000", growth: "+200%" }
    ],
    timeline: "30 dias",
    mainMetric: "+200%",
    mainMetricLabel: "Crescimento MRR"
  },
  {
    id: 7,
    company: "Salão Glamour Hair",
    category: "Salão de Beleza",
    owner: "Patrícia Almeida",
    role: "Proprietária",
    image: "https://readdy.ai/api/search-image?query=Modern%20beauty%20salon%20interior%20elegant%20hair%20styling%20stations%20mirrors%20warm%20lighting%20luxurious%20feminine%20decor%20professional%20hairdressing%20environment%20pink%20gold%20accents&width=600&height=400&seq=case7&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-woman-beauty-salon-owner-age-40-curly-dark-hair-elegant-makeup-wearing-stylish-black-dress-gold-accessories-warm-smile-confident-professional-portrait-salon-background-blurred-studio-lighting&width=200&height=200&seq=owner-patricia-almeida&orientation=squarish",
    logo: "GH",
    testimonial: "Minhas clientes adoram poder agendar a qualquer hora pelo WhatsApp. A IA conhece todos os serviços, preços e disponibilidade das profissionais. Reduzi 80% das ligações e aumentei muito os agendamentos.",
    challenge: "Recepcionista não conseguia atender todas as ligações durante os horários de pico. Muitas clientes desistiam de agendar.",
    solution: "IA treinada com todos os serviços do salão, preços, tempo de cada procedimento e agenda das profissionais para agendamento automático.",
    results: [
      { metric: "Agendamentos", before: "180/mês", after: "320/mês", growth: "+78%" },
      { metric: "Faturamento", before: "R$ 28.000", after: "R$ 49.600", growth: "+77%" },
      { metric: "No-shows", before: "25%", after: "8%", growth: "-68%" },
      { metric: "Satisfação Clientes", before: "78%", after: "96%", growth: "+23%" }
    ],
    timeline: "28 dias",
    mainMetric: "+78%",
    mainMetricLabel: "Mais Agendamentos"
  },
  {
    id: 8,
    company: "Restaurante Sabor & Arte",
    category: "Restaurante",
    owner: "Chef Eduardo Lima",
    role: "Chef Proprietário",
    image: "https://readdy.ai/api/search-image?query=Modern%20upscale%20restaurant%20interior%20elegant%20dining%20room%20warm%20ambient%20lighting%20wooden%20tables%20contemporary%20design%20fine%20dining%20atmosphere%20sophisticated%20decor&width=600&height=400&seq=case8&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-chef-man-age-48-short-gray-beard-wearing-white-chef-coat-friendly-warm-smile-professional-culinary-expert-restaurant-kitchen-background-blurred-portrait-natural-lighting&width=200&height=200&seq=owner-eduardo-lima&orientation=squarish",
    logo: "SA",
    testimonial: "A IA gerencia todas as reservas, responde sobre o cardápio, informa sobre ingredientes para alérgicos e até sugere harmonizações. Meus garçons agora focam 100% no atendimento presencial.",
    challenge: "Telefone tocando constantemente atrapalhava o serviço. Muitas reservas eram perdidas por falta de atendimento.",
    solution: "IA para gestão completa de reservas, informações sobre cardápio, eventos especiais e pedidos de delivery integrado.",
    results: [
      { metric: "Reservas", before: "95/mês", after: "185/mês", growth: "+95%" },
      { metric: "Delivery", before: "R$ 12.000", after: "R$ 28.000", growth: "+133%" },
      { metric: "Ticket Médio", before: "R$ 85", after: "R$ 110", growth: "+29%" },
      { metric: "Faturamento Total", before: "R$ 85.000", after: "R$ 156.000", growth: "+84%" }
    ],
    timeline: "35 dias",
    mainMetric: "+84%",
    mainMetricLabel: "Aumento Faturamento"
  },
  {
    id: 9,
    company: "Escola Futuro Brilhante",
    category: "Escola",
    owner: "Profa. Renata Campos",
    role: "Diretora Pedagógica",
    image: "https://readdy.ai/api/search-image?query=Modern%20private%20school%20interior%20bright%20colorful%20classroom%20educational%20environment%20contemporary%20learning%20space%20children%20furniture%20natural%20lighting%20welcoming%20atmosphere&width=600&height=400&seq=case9&orientation=landscape",
    ownerImage: "https://readdy.ai/api/search-image?query=brazilian-woman-school-director-age-52-short-auburn-hair-glasses-wearing-elegant-burgundy-cardigan-pearl-necklace-warm-maternal-smile-professional-educator-portrait-school-office-background-natural-lighting&width=200&height=200&seq=owner-renata-campos&orientation=squarish",
    logo: "FB",
    testimonial: "Os pais podem tirar dúvidas sobre mensalidades, calendário escolar, eventos e até acompanhar comunicados a qualquer hora. Nossa secretaria reduziu 70% das ligações e focamos no que importa: educação.",
    challenge: "Secretaria sobrecarregada com ligações de pais. Informações importantes não chegavam a tempo. Processo de matrícula demorado.",
    solution: "IA para atendimento a pais e responsáveis, informações sobre matrículas, calendário, eventos e comunicados escolares.",
    results: [
      { metric: "Matrículas Novas", before: "45/ano", after: "82/ano", growth: "+82%" },
      { metric: "Tempo Secretaria", before: "8h/dia", after: "2h/dia", growth: "-75%" },
      { metric: "Satisfação Pais", before: "72%", after: "94%", growth: "+31%" },
      { metric: "Rematrículas", before: "78%", after: "95%", growth: "+22%" }
    ],
    timeline: "40 dias",
    mainMetric: "+82%",
    mainMetricLabel: "Mais Matrículas"
  }
];
